import React from "react";
import styled from "styled-components";
import { Button } from "./button/Button";
import { colors } from "./colors/color";
import { Flex } from "./compositeComponents/FlexHelpers";
import { Icon, iconName } from "./icons/Icons";
import { tableStyles } from "./styles/tableStyles";
import { TooltipTheOneWrapper } from "./TooltipTheOne";

export const Table = styled.table<{fontSizePx?:number, showOuterBorder?:boolean}>`
    border-collapse: collapse;
    width: 100%;
    ${props => props.showOuterBorder ? tableStyles(colors).border : ''}
    thead {
        border-bottom: ${tableStyles(colors).border};
        th {
            font-weight: 700;
            font-size: ${props => props.fontSizePx ? `${props.fontSizePx}px` : '16px'};
            line-height: 24px;
            letter-spacing: 0.5px;
            padding: 12px 4px;
            text-align: left;
            color: ${colors.table.headerText};
            font-weight: bold;
            text-align: left;
            button {
                font-weight: bold;
            }
        }
    }
    tr {
        td {
            padding-top:12px;
            padding-bottom:12px;
            padding-left:12px;
            padding-right:12px;
            color:${colors.table.cellText};
            text-align: left;
            font-size: ${props => props.fontSizePx ? `${props.fontSizePx}px` : '16px'};
            border-bottom: ${tableStyles(colors).border};
        }
        td:first-child{
            padding-left:4px;
        }
        td:last-child{
            padding-right:4px;
        }
    }
`;

type TableRowWithOnClickProps =
    {
        onClick?: () => void,
        children: React.ReactNode
    };
export function TableRowWithOnClick (props: TableRowWithOnClickProps): JSX.Element
{
    return (
        <>
            {props.onClick
                ? <TrWithOnClick onClick={props.onClick}>
                    {props.children}
                </TrWithOnClick>
                : <tr>
                    {props.children}
                </tr>
            }
        </>
    );
}

const TrWithOnClick = styled.tr`
    cursor:pointer;
    &:hover {
        background-color:${colors.table.backgroundHover};
    }

    /* &:nth-child(even){
        background-color:${colors.table.trEven};

        &:hover {
            background-color:${colors.table.backgroundHover};
        }
    } */
`;

type TableHeaderWithSortProps = {
    text: string,
    width?:string,
    isActiveSort: boolean,
    ascending: boolean,
    onClick: (ascending: boolean) => void;
};
export function TableHeaderWithSort (props: TableHeaderWithSortProps): JSX.Element
{
    return (
        <th style={{ whiteSpace: 'nowrap', paddingLeft: '8px', width: props.width }}>
            <Flex flexDirection='row' alignItems='center'>
                <span>{props.text}</span>
                <SortDirectionButton isActiveSort={props.isActiveSort} ascending={props.ascending} onClick={props.onClick} />
            </Flex>
        </th>
    );
}

type TableHeaderIconProps = {
    icon: iconName,
    tooltipContent:React.ReactNode,
    width?: string,
};
export function TableHeaderIcon (props: TableHeaderIconProps): JSX.Element
{
    return (
        <th style={{ whiteSpace: 'nowrap', paddingLeft: '8px', width:props.width }}>
            <Flex flexDirection='row' alignItems='center'>
                <TooltipTheOneWrapper tooltipContent={props.tooltipContent} >
                    <Icon name={props.icon} />
                </TooltipTheOneWrapper>
            </Flex>
        </th>
    );
}

type TableHeaderIconWithSortProps = {
    icon: iconName,
    tooltipContent:React.ReactNode,
    isActiveSort: boolean,
    ascending: boolean,
    width?: string,
    onClick: (ascending: boolean) => void;
};
export function TableHeaderIconWithSort (props: TableHeaderIconWithSortProps): JSX.Element
{
    return (
        <th style={{ whiteSpace: 'nowrap', paddingLeft: '8px', width: props.width }}>
            <Flex flexDirection='row' alignItems='center'>
                <TooltipTheOneWrapper tooltipContent={props.tooltipContent} >
                    <Icon name={props.icon} />
                </TooltipTheOneWrapper>
                <SortDirectionButton isActiveSort={props.isActiveSort} ascending={props.ascending} onClick={props.onClick} />
            </Flex>
        </th>
    );
}

type SortDirectionButtonProps = {
    isActiveSort: boolean,
    ascending: boolean,
    onClick: (ascending: boolean) => void;
};
export function SortDirectionButton (props: SortDirectionButtonProps): JSX.Element
{
    let stateIcon: iconName = 'caret_selector';
    if (props.isActiveSort)
        stateIcon = props.ascending ? 'caret_caretDown' : 'caret_caretUp';

    return (
        <Button variant='text' text='' onClick={() => props.onClick(props.isActiveSort ? !props.ascending : true)} icon={stateIcon} />
    );
}



